module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1792157180594.png";